/// <summary>
/// This object does the complete menu and highchart handling in the topology. <br/>
/// It shows the initial tree and allows for adding/removing and changing branches of the tree
/// Author: MWI<br />
/// Date: 5.10.2015<br />
/// Copyright ©: EUDT GmbH 2015 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.1.2 - 07.07.2017                                              *<br />
/// **********************************************************************<br />
/// * - signal circle hidden when dragging nodes                         *<br />
/// **********************************************************************<br />
/// **********************************************************************<br />
/// *** v1.1.1 - 11.11.2016                                              *<br />
/// **********************************************************************<br />
/// * -  various bug fixes and stabilizations                            *<br />
/// **********************************************************************<br />
/// **********************************************************************<br />
/// *** v1.1.0 - 11.11.2016                                              *<br />
/// **********************************************************************<br />
/// * -  added Plus/Minus for easier adding/removing of Signals          *<br />
/// * -  updated DeleteNode Slightly                                     *<br />
/// **********************************************************************<br />
/// *** v1.0.1 - 17.12.2015                                              *<br />
/// **********************************************************************<br />
/// * -  fixed bug that added extra signals                              *<br />
/// * -  fixed bug that hindered the chkAll checkbox from working        *<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 5.10.2015                                               *<br />
/// **********************************************************************<br />
/// * -  inherited from vcSignalTopology js                              *<br />
/// * -  changed only a few functions                                    *<br />
/// **********************************************************************<br />
/// </summary>
function vcTopologyBuild(options) {
    var me = this;
    try {
        window.vcSignalTopology.call(me, options);
    } catch (ex) {
        window.writeError("vcTopologyBuild.constructor");
       
    }
}
vcTopologyBuild.prototype = Object.create(window.vcSignalTopology.prototype);
vcTopologyBuild.prototype.constructor = window.vcSignalTopology;
vcTopologyBuild.prototype.setNodeClass = function (d) {
    try {
        if (d.signalid === "-1") {
            return "node nA";
        } else {
            return "node";
        }
    } catch (ex) {
        return "node";
    }
};
vcTopologyBuild.prototype.init = function () {
    ///<summary>
    /// This function initializes the Object <br/>
    /// therefore it first calls init from the Base Class <br/>
    /// and then make modifications and adds own nodes for example
    ///</summary>
    var me = this;
    try {
       


        window.vcSignalTopology.prototype.init.call(me);
        if (me.divTop) {
            me.divTop.css({
                "height": 30 + "px"
            });
        }
        me.addNode = me.baseSvg.append("g")
            .attr('id', 'addNode')
            .attr('transform', "translate(-8,8)")
            .attr('pointer-events', 'mouseover')
            .attr("cursor", "pointer")
            .on("click", function() {
                window.d3.event.stopPropagation();
                me.addSignals(me);
            });
        me.addNode
            .append("circle")
            .attr("class", "addCircle")
            .attr("fill", "#A8E001")
            .attr("stroke", "steelblue")
            .attr("stroke-width", "1.5px")
            .attr("r", 60)
            .attr("cx", 40)
            .attr("cy", 0);

        var addText = me.addNode.append('text');
        addText.append("tspan").attr("dy", "1.4em").attr("x", 12).text(me.settings.resources.signals);
        addText.append("tspan").attr("dy", "1.2em").attr("x", 12).text(me.settings.resources.addSig);
        me.delNode = me.baseSvg.append("g")
            .attr('id', 'delNode')
            .attr('transform', "translate("+ (me.baseSvg.node().getBoundingClientRect().width - 70) + ",0)")
            .attr('class', 'node')
            .datum({ id: "delNode", signalid: "-2" })
            .attr('pointer-events', 'mouseover').on("mouseover", function(node) {
                me.overCircle(me, node);
            })
            .on("mouseout", function() {
                me.outCircle(me);                            
            }).on("click", function() {
                me.delNodeClick(me);
            });

        me.delNode.append("circle").attr("class", "delCircle").attr("r", 60).attr("cx", 25).attr("cy", 0);
        var delText = me.delNode.append('text');

        delText.append("tspan").attr("style", "fill:white").attr("dy", "3em").attr("x", 10).text(me.settings.resources.delSig);

        $("<div>").attr("id", "btnSave").attr("class", "btnMainItem twothirds active").html("<i class='fa fa-save'></i><br/>" + me.settings.resources.save).appendTo(me.visual.find('#divTreeTop')).on("click", function() { me.save(me); });
        me.visual.find("#divTreeTop").addClass("vc-grid-8col");
                    me.isNormalScreen = true;

                          //$("<div>").attr("id", "btnFullScreen").attr("class", "btnMainItem twothirds").button().html("<i class='fa fa-arrows-alt'></i><br/> VOLLBILD").appendTo(me.visual.find('#divTreeTop')).on("click", function() { me.setFullScreen(me.isNormalScreen); });

     //   console.info(me.unassigned);

        me.visual.append(me.createUnassignedDiv(me.unassigned));
        me.visual.find("#div-unass-group").off("change").on("change", function() { me.unassFilter(); });
        me.visual.find("#topo-unassigned-filter").vcFilter({ callback: function () { me.unassFilter(); }});
        me.visual.find("#divUnass").off("click", ".fa-info-circle").on("click", ".fa-info-circle",
            function() {
                me.vcVisual.showSignalAnalogSummaryDialog($(this).data("id"));
            });
    } catch (ex) {
        me.writeError("TopoBuild-init", ex);
    }
};
vcTopologyBuild.prototype.createUnassignedDiv = function (unassigned) {
    /// <summary>As the name says this creates the DIV below where all Signals that are not yet assigned appear</summary>
    /// <param name="unassigned" type="array">the array of nodes containing the unassigned Signals</param>
    var me = this;
    var sInactive;
    try {

       
      
        var groupFilter = $(me.settings.addList).find(".vc-grid-2col.signal-select-group").clone();
       groupFilter.find("select").attr("id", "div-unass-group");
        var sRet = "<div id='divUnass' class='vc-list signal-list vc-list-border vc-grid-2col' >";
            sRet += "<ul class='vc-list-header color-bg-primary'><li class='vc-list-item'>" + me.settings.resources.unassigned + "<br/><div id='topo-unassigned-filter' class='topo-unassigned-filter vc-filter'></div><div class=' signal-select-group'>"+ groupFilter.html() +"</div></li></ul><div id='topo-unassigned-list' class='vc-list-table selectable-list'>";
        sInactive = "inactive";
        for (var i = 0; i < unassigned.length; i++) {
            //<i class='fa fa-signal icon' title='Signal'></i>
                sRet += "<li data-unassgroup='" + unassigned[i].groupname + "'  id='bsaid" + unassigned[i].signalid + "' data-bsagid='" + unassigned[i].bsagid + "' data-bsaid='" + unassigned[i].signalid + "' class='vc-list-item ";
            if (i % 2 === 1) {
                sRet += " alt ";
            }
                if (window._menu && window._menu.interval < unassigned[i].allowedInterval) {
                    sRet += sInactive;

                }
            sRet += "'>";
         
            sRet += unassigned[i].name + "<i data-id='" + unassigned[i].signalid + "' class='vc-list-icon fa-regular fa-lg fa-info-circle color-font-secondary'></i>" + "</li>";
        }
        sRet += "</div></div>";
                                                                         
        return sRet;
    } catch (ex) {
        me.writeError('unassignedDiv', ex);
        return "";
    }
};
vcTopologyBuild.prototype.save = function (me) {
    ///<summary>
    /// This function prepares for the saving of the whole topology <br/>
    /// it takes the current nodes and retrieves the connections between them
    ///</summary>
    try {
        me.showInfo("", "", false);
        var saveTopology = { "type": 3 };
        var links = [];
      
        me.visit(me.nodes,function(d) {links.push(d);},function(z)  {if (me.hasChildStatus(z.childStatus, me.ENUM_CHILD_STATUS.SHOWN)) {return z.children;} else if (me.hasChildStatus(z.childStatus, me.ENUM_CHILD_STATUS.HIDDEN)) {return z._children;} else return null;});

                var tempTopo = [];
                var tempBsaid;
                for (var i = 0; i <= links[0].length - 1; i++) {
                    if (links[0][i].signalid !== "-1") {
                        tempBsaid = {};
                        tempBsaid.bsaid = links[0][i].signalid;
                        tempBsaid.count = links[0][i].count;
                        tempBsaid.parentBsaid = links[0][i].parent.signalid;
                        tempBsaid.parentCount = links[0][i].parent.count;
                        if ((me.hasChildStatus(links[0][i].childStatus, me.ENUM_CHILD_STATUS.HIDDEN))) {

                            for (var z = 0; z < links[0][i]._children.count; z++) {
                                tempBsaid = {};
                                tempBsaid.bsaid = links[0][i]._children[z].signalid;
                                tempBsaid.count = links[0][i]._children[z].count;
                                tempBsaid.parentBsaid = links[0][i].signalid;
                                tempBsaid.parentCount = links[0][i].count;
                                tempTopo.push(tempBsaid);

                            }
                        }
                        if (links[0][i].specialChildren &&
                            links[0][i].specialChildren.length > 0 &&
                            Array.isArray(links[0][i].specialChildren)) {
                            tempBsaid.extraChildren = '';
                            for (var j = 0; j <= links[0][i].specialChildren.length - 1; j++) {
                                tempBsaid.extraChildren += links[0][i].specialChildren[j].signalid +':' +links[0][i].specialChildren[j].count +';';
                            }
                        }
                        tempTopo.push(tempBsaid);
                    }
                }
                saveTopology.topo = tempTopo;
                window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 42, 42, "", "", me.deviceType, 2, JSON.stringify(saveTopology), function (result) {
                    var res = JSON.parse(result);
                        if (res.saveOk) {
                            me.updateTree(res.newSignals);
                            me.showInfo(me.settings.resources.saved, false);
                            me.visual.find('#btnSacreve').button('option', 'disabled', false);
                        } else {
                            me.showInfo(me.settings.resources.notSaved, res.text, true);
                        }
                    });
    } catch (ex) {
        me.writeError("Save", ex);
    }
};

vcTopologyBuild.prototype.delNodeClick = function (me) {
    /// <summary>Click Handler function that only appears on the deletionNode <br/>
    /// calls an deletion dialog and ask for confirmation to delete all signals out of the current tree</summary>
    try {

     
        var divDialog = $("<div>").html(me.settings.resources.deleteAll_info);
        divDialog.dialog({
            resizable: false,
            title: me.settings.resources.deleteAll_conf,
            height: 140,
            modal: true,
            dialogClass: "no-close topo-dialog",
            draggable: false,
            buttons: [
                {
                    text: me.settings.resources.yes,
                    click: function() {
           me.visit(me.root, function (d) {
                  if (me.visual.find("#divUnass .vc-list-item#bsaid" & d.id).length === 0) {

                      me.visual.find("#divUnass .vc-list-table").append($("<li data-unassgroup='" + d.groupname + "' id='bsaid" + d.id + "' data-bsagid='" + d.bsagid + "' class='vc-list-item'>" + d.name + "<i data-id='" + d.id +"' class='vc-list-icon fa-regular fa-lg fa-info-circle color-font-secondary'></i></li>"));
                  }
        }, function (d) {
            return d.children && d.children.length > 0 ? d.children : null;
        });
                        me.root.children = [];
                        me.updateTree(me.root, true);
                        me.unassFilter();
                        $(this).dialog("close");
                    }
                },
                {
                    text: me.settings.resources.no,
                    click: function() {
                        $(this).dialog("close");
                    }
                }
            ]
        });
        $(".ui-widget-overlay").height("300%").off("click").on("click", function() { divDialog.dialog("close"); });
    } catch ( ex ) {
        me.writeError("TopoBuild-DelNodeClick", ex);
    }

};
vcTopologyBuild.prototype.addListFilter = function () {
    /// <summary>
    /// As the name says this adds the event to the filter div <br/>
    /// </summary>
    var me = this;
    var bRet = true;
    var iTmpBsagid;
    try {
        if (me.error) {
            bRet = false;
        } else {
           
            $("#signalAddFilter").vcFilter({ callback: function () { me.Listfilter(); }});
            $("#signal-add-select-group").off("change").on("change", function () {me.Listfilter(); });
            iTmpBsagid = window.d3.select(".node.nA").datum().bsagid;
            if (iTmpBsagid === null) {
                iTmpBsagid = -1;
               }
            $("#signal-add-select-group").val(iTmpBsagid).trigger("change");
        }   
    } catch (ex) {
        me.writeError("ProjectOverview.addFilter", ex);
        bRet = false;
    }
    return bRet;
};
vcTopologyBuild.prototype.Listfilter = function () {
    /// <summary>
    /// This function handles the entry filtering.
    /// </summary>
    var me = this;
    var bsagid;
    try {
        if (me.error) {
            return false;
        }
                //hide all
        me.visual.find(".tree-add-signal").removeClass("found").data("counter", 0).hide();
                me.setTagFilter("#signalAddFilter", ".tree-add-signal", "found");

        //me.dialog.find(".tree-add-signal").show();
        bsagid = me.visual.find("#signal-add-select-group").val();
        if (bsagid !== "-1") {
            me.visual.find(".tree-add-signal[data-bsagid!='" + bsagid + "'].found").removeClass("found");
        } 
        me.visual.find(".tree-add-signal.found").show();
        me.visual.find(".tree-add-signal").removeClass("alt");
        me.visual.find(".tree-add-signal.found:even").addClass("alt");

        return true;
    } catch (ex) {
        me.writeError('filter', ex); return false;
    }
};   

vcTopologyBuild.prototype.unassFilter = function () {
    /// <summary>
    /// This function handles the entry filtering.
    /// </summary>
    var me = this;
    var bsagid;
    try {
        if (me.error) {
            return false;
        }
                //hide all
        me.visual.find("#topo-unassigned-list .vc-list-item").removeClass("found").data("counter", 0).hide();
        me.setTagFilter("#topo-unassigned-filter", "#topo-unassigned-list .vc-list-item", "found");

          bsagid = me.visual.find("#div-unass-group").val();
        if (bsagid !== "-1") {
            me.visual.find(".vc-list-item[data-bsagid!='" + bsagid + "'].found").removeClass("found");
        } 
        //me.dialog.find(".tree-add-signal").show();
        me.visual.find("#topo-unassigned-list .vc-list-item.found").show();
        me.visual.find("#topo-unassigned-list .vc-list-item").removeClass("alt");
        me.visual.find("#topo-unassigned-list .vc-list-item.found:even").addClass("alt");

        return true;
    } catch (ex) {
        me.writeError('filter', ex); return false;
    }
};

vcTopologyBuild.prototype.splitListFilter = function (val) {
    /// <summary>
    /// This function splits a single filter input and finds all entries which contain the filter expression.
    /// </summary>
    var me = this;
    var filter;
    var i;
    try {
        if (me.error) {
            return false;
        }
        var addNodeData = window.d3.select(".nA").datum();

        //get filter expressions
        filter = val.trim();
        if (filter.length > 0) {
            filter = filter.split(" ");
            for (i = 0; i < filter.length; i++) {
                if (filter[i].length > 0) {
                    if (addNodeData.signalid !== "-1") {

                        $("#divSignalsSelection tbody tr[data-measureunit='" +
                            window.d3.select(".nA").datum().measureunit +
                            "']:contains('" +
                            filter[i] +
                            "')").addClass("found");

                    } else {

                        $("#divSignalsSelection tbody tr:contains('" +
                            filter[i] +
                            "')").addClass("found");
                    }
                }
            }
        } else {
            if (addNodeData.signalid !== "-1") {
                me.dialog.find(".tree-add-signal[data-measureunit='" +window.d3.select(".nA").datum().measureunit +"']").each(function(idx, element) { $(element).addClass("found") });

            } else {
                $("#divSignalsSelection tbody tr").addClass("found");
            }
        }
       
        return true;
    } catch (ex) {
        me.writeError('splitFilter', ex); return false;
    }
};
vcTopologyBuild.prototype.initiateNodeDrag = function (d, domNode) {
    ///<summary>
    /// as the name says it intializes the dragging of a Node <br/>
    /// it creates therefore some ghost circles and prepares everything
    ///</summary>
    var me = this;
    try {
        me.draggingNode = domNode;
        
        domNode.attr("class", "node nD");
        window.d3.selectAll('.ghostCircle').filter(function (currentSelection) {
            return d.id !== currentSelection.id;
        }).attr('class', 'ghostCircle show');
        window.d3.select(".delCircle").attr("style", "opacity:0.5");
        window.d3.selectAll(".nodeCircle").attr("style", "display:none");
        me.svgGroup.selectAll(".link").filter(function (link) {
            return (link.target.id === d.id && link.source.id === d.parent.id) || (link.source.id === d.id);
        }).remove();
        me.svgGroup.selectAll(".node").filter(function (currentNode) {
            return currentNode.parent && d.id === currentNode.parent.id;
        }).remove();
        return true;
    } catch (ex) {
        me.writeError("initiateNodeDrag-build", ex);
        return false;
    }
};
vcTopologyBuild.prototype.appendStyleElement = function (nodeEnter) {
    ///<summary>
    ///Appends the styling elements for the corresponding tree <br />
    ///furthermore, adds sometimes clicklistener and DragListener to other elements
    ///</summary>
    var me = this;
    try {
       
        if (me.ieVersion === -1  || me.ieVersion > 11) {
            me.addStyleElementsNotIe(nodeEnter);
        } else {
            me.addStyleElementsInternetExplorer(nodeEnter);
        }


        me.addNodeDragListener(nodeEnter);
    } catch (ex) {
        me.writeError("appendStyleElement-build", ex);
    }
};
vcTopologyBuild.prototype.addStyleElementsInternetExplorer = function(nodeEnter) {
    var me = this;
    try {
        me.addCommonStyles(nodeEnter);

        nodeEnter.append("text")
            .attr("class", "extraFont fa fa-lg")
            .attr("style", "font-size:1.5em; fill: #A8E001; paint-order: stroke; stroke: black; stroke-width:1px;")
            .text("\uf0fe")
            .attr("dx", me.nodeWidth - 30)
            .attr("dy", -12).on("click",
                function(d) {
                    me.baseSvg.selectAll(".nA").attr("class", "node");
                    me.baseSvg.select("#node" + d.id).attr("class", "node nA");
                    setTimeout(function() {
                            me.addSignals(me);
                        },
                        100);
                });
        nodeEnter.append("text")
            .attr("class", "extraFont fa fa-lg")
            .attr("style", "font-size:1.5em; fill:red; paint-order: stroke; stroke: black; stroke-width:1px")
            .text("\uf146")
            .attr("dx", me.nodeWidth - 30)
            .attr("dy",25).on("click", function(d) { me.deleteNode(d); });
        nodeEnter.select(".nodeName").attr("x", me.nodeWidth - 30);
        nodeEnter.select(".nodeInfo").attr("dx", me.nodeWidth - 10);
    } catch (ex) {
        me.writeError("vcTopologyBuild.appendStyleNotIE", ex);

    }
};
vcTopologyBuild.prototype.addCommonStyles = function(nodeEnter) {
    var me = this;
    try {
                nodeEnter.append("circle")
            .attr('class', 'ghostCircle')
            .attr("r", 25)
            .attr('pointer-events', 'mouseover')
            .on("mouseover",
                function(node) {
                    me.overCircle(me, node);
                })
            .on("mouseout",
                function() {
                    me.outCircle(me);
                }).attr("transform", "translate(" + me.nodeWidth + ",0)");

        nodeEnter.append("circle")
            .attr("r", 9).attr("class",
                function(d) {
                    if (d.isGenerator === "True")
                        return "nodeCircle circleGen";
                    else return "nodeCircle";
                }).attr("transform", "translate(" + me.nodeWidth + ",0)");

    } catch (ex) {
                       me.writeError("vcTopologyBuild.addCommonStyles", ex);

    }
}
vcTopologyBuild.prototype.addStyleElementsNotIe = function(nodeEnter) {
    var me = this;
    try {

        me.addCommonStyles(nodeEnter);
        var obj = nodeEnter.select(".nodeTextDiv");
        obj.select(".nodeName").on("click",
            function(d) {
                me.baseSvg.selectAll(".nA").attr("class", "node");
                me.baseSvg.select("#node" + d.id).attr("class", "node nA");
            });
        var icons = obj.insert("div", ".nodeTextContent").attr("class", "add-remove-icons");
        icons.append("i")
            .attr("class", "extraFont fa fa-lg fa-plus-square node-add color-font-primary ")
            .on("click",
                function(d) {
                    me.baseSvg.selectAll(".nA").attr("class", "node");
                    me.baseSvg.select("#node" + d.id).attr("class", "node nA");
                    setTimeout(function() {
                            me.addSignals(me);
                        },
                        100);
                });
        icons.append("i")
            .attr("class", "extraFont fa fa-lg fa-minus-square node-remove icon-color-error")
            .on("click", function(d) { me.deleteNode(d); });
    } catch (ex) {
                me.writeError("vcTopologyBuild.appendStyleNotIE", ex);

    }
}

vcTopologyBuild.prototype.addNodeDragListener = function(nodeEnter) {
    var me = this;
    try {
        var nodeDragListener = window.d3.behavior.drag()
            .on("dragstart",
                function(d) {
                    if (d === me.root) {
                        return;
                    }
                    //window.d3.select(".nodeBox").attr("style", "");
                    //window.d3.select(this).select(".nodeBox").attr("style",
                    //    "stroke:black; stroke-width:1px; fill:light-grey; opacity:0.6; ");
                    window.d3.event.sourceEvent.stopPropagation();
                    if (window.d3.event.sourceEvent.altKey) {
                        me.altKeyPressed = true;
                        //window.d3.selectAll(".ghostCircle").classed("ghost-circle-additional",true);
                    }
                })
            .on("drag",
                function(d) {
                    if (d === me.root) {
                        return;
                    }
                    me.panListener($(this), d);
                    var node = window.d3.select(this);
                    d.x0 += (window.d3.event.dy);
                    d.y0 += (window.d3.event.dx);
                    node.attr("transform", "translate(" + (d.y0 - me.nodeWidth) + "," + d.x0 + ")");
                    me.initiateNodeDrag(d, node);
                    me.updateTempConnector();
                })
            .on("dragend",
                function(d) {
                    if (me.draggingNode) {
                        if (d === me.root) {
                            return;
                        }
                        if (d.id === '-2') {
                            me.deleteNode(me.draggingNode.datum());
                        }
                        if (me.altKeyPressed === true) {
                            me.addSpecialChild();
                        } else {
                            me.addToNewParent();
                        }
                        me.baseSvg.selectAll('.ghostCircle').classed("show", false);
                        me.baseSvg.select(".delCircle").attr("style", "opacity:1");
                        me.baseSvg.selectAll('.nodeCircle').attr("style", "display:block");
                        //d.attr('class', 'node');
                        me.draggingNode.select(".nodeBox").attr("style", "stroke:white; stroke-width:1px;");
                        me.draggingNode = null;
                        me.altKeyPressed = false;
                        me.updateTempConnector();
                        me.updateTree(me.nodes, false);

                    }
                });
        nodeEnter.call(nodeDragListener);
    } catch (ex) {
                me.writeError("vcTopologyBuild.addNOdeDragListener", ex);

    }

};
vcTopologyBuild.prototype.deleteNode = function (delNode) {
    ///<summary>
    /// Deletes a Node from the Tree <br/>
    /// therefore also changes parents of possible child nodes <br/>
    ///</summary>
    ///<param name="delNode" type="node">The Node to delete</param>
    var me = this;
    var indexInParent;
    var updateNode;
    var isRoot = false;
    try {
        var draggingData = me.baseSvg.select('#node' + delNode.id).datum();
        if (me.visual.find("#divUnass .vc-list-item#bsaid" & delNode.id).length === 0) {

            me.visual.find("#divUnass .vc-list-table").append($("<li data-unassgroup='" + delNode.groupname + "' id='bsaid" + delNode.id + "' data-bsagid='" + delNode.bsagid + "' class='vc-list-item'>" + delNode.name + "<i data-id='" + delNode.id +"' class='vc-list-icon fa-regular fa-lg fa-info-circle color-font-secondary'></i></li>"));
            me.unassFilter();
        }
        if (delNode.id === "-1_-1") {
            delNode.children = [];
            updateNode = delNode;
            isRoot = true;
        } else {
            if (draggingData.children) {
                draggingData.parent.children.push.apply(draggingData.parent.children, delNode.children);
            }
            if (draggingData._children) {
                draggingData.parent.children.push.apply(draggingData.parent.children, delNode._children);
            }
            indexInParent = draggingData.parent.children.indexOf(delNode);
            draggingData.parent.children.splice(indexInParent, 1);
            updateNode = draggingData.parent;
        }

        me.updateTree(updateNode, isRoot);
    } catch (ex) {
        me.writeError("deleteNode-build", ex);
    }
};
vcTopologyBuild.prototype.addSpecialChild = function () {
    var me = this;
    var bRet;
    try {
        var draggingData = me.baseSvg.select('#' + me.draggingNode.attr("id")).datum();
        if (draggingData.specialChildren === undefined || draggingData.specialChildren === "" || draggingData.specialChildren === "none") {
            draggingData.specialChildren = [];
        }
        draggingData.specialChildren.push(me.selectedNode);
        window.d3.select('#node' + draggingData.id).data(draggingData);
        me.setChildStatus(draggingData, me.ENUM_CHILD_STATUS.SPECIAL_SHOWN);
        me.updateTree(window.d3.select('#node' + draggingData.id), false);
        bRet = true;
    } catch (ex) {
        me.writeError("addSpecialChild", ex);
        bRet = false;
    }
    return bRet;
};
vcTopologyBuild.prototype.updateTempConnector = function () {
    ///<summary>
    /// Function to update the temporary connector indicating dragging affiliation <br/>
    /// it creates a small connector on the mouseover in the red circle
    ///</summary>
    var me = this;
    var data = [];
    try {
        // disallow same signalids to be connected
        if ((me.draggingNode !== null && me.selectedNode !== null) && (me.draggingNode.signalid !== me.selectedNode.signalid && me.selectedNode.signalid !== "-2")) {
            // have to flip the source coordinates since we did this for the existing connectors on the original tree
            var draggingData = window.d3.select('#' + me.draggingNode.attr("id")).datum();
            data = [
                {
                 
                    source: {
                        x: me.selectedNode.y0,
                        y: me.selectedNode.x0
                    },
                    target: {
                        x: draggingData.y0,
                        y: draggingData.x0
                    }
                }
            ];

        }
            var tempLink = me.svgGroup.selectAll(".templink").data(data);

        tempLink.enter().append("path")
            .attr("class", "templink")
            .attr("d",   window.d3.svg.diagonal()).attr('pointer-events', 'none');

            tempLink.attr("d", window.d3.svg.diagonal());

            tempLink.exit().remove();


    } catch (ex) {

        me.writeError("updateTempConnector", ex);
    }
};
vcTopologyBuild.prototype.addToNewParent = function () {
    /// <summary>
    /// Function that adds a dragged node to its new parent node <br/>
    /// It does so by doing array manipulations on the corresponding nodes <br />         
    ///</summary> 
    /// <param name="me" type="vcTopologyBuild">the Object itself to call functions</param>
    /// <param name="d" type="Node">the node the click happend</param>
    var me = this;
    try {
        if (me.selectedNode) {
            var draggingNodeData = window.d3.select('#' + me.draggingNode.attr('id')).datum();
            if (me.selectedNode.signalid === "-1" || me.selectedNode.signalid === "-2" || (me.selectedNode.measureunit === draggingNodeData.measureunit)) {
                if (!me.selectedNode.children) {
                    me.selectedNode.children = [];
                }
                var parentChildren = window.d3.select('#node' + draggingNodeData.parent.id).datum().children;
                var result = $.grep(parentChildren, function(e) { return e.id !== draggingNodeData.id; });
                window.d3.select('#node' + draggingNodeData.parent.id).datum().children = result;
                me.selectedNode.children.push(draggingNodeData);
                me.updateTree(me.selectedNode, false);
            }
        }
    } catch (ex) {

        me.writeError("addToNewParent", ex);
    }
};
vcTopologyBuild.prototype.overCircle = function (me, d) {
    /// <summary>Function called for the mouseover-event from the extra added ghostCircle</summary>
    /// <param name="me" type="vcTopologyBuild">the Object itself to call functions</param>
    /// <param name="d" type="Node">the node the click happend</param>
    try {
        me.selectedNode = d;
            //window.d3.select("#node" + me.selectedNode.id).selectAll('circle.nodeCircle').attr("style", "display:none");

         me.updateTempConnector();
    } catch (ex) {

        me.writeError("TopoBuild-overCircle", ex);
    }
};
vcTopologyBuild.prototype.outCircle = function (me) {
    /// <summary>Function called for the mouseout-event from the extra added ghostCircle</summary>
    /// <param name="me" type="vcTopologyBuild">the Object itself to call functions</param>
    try {
                    //window.d3.select("#node" + me.selectedNode.id).selectAll('circle.nodeCircle').attr("style", "display:block");
        //me.svgGroup.selectAll(".templink").remove();
        me.selectedNode = null;
       me.updateTempConnector();
    } catch (ex) {

        me.writeError("TopoBuild-outCircle", ex);
    }
    //updateTempConnector();
};
vcTopologyBuild.prototype.updateLink = function () {
    ///<summary>
    ///override function the base method to add special function to links, <br />
    ///in this case it is only for additional links to add the "AltKey onClick" remove
    ///</summary>
    var me = this;
    try {
        window.d3.selectAll(".additionalParentLink").on("click", function () {
            if (window.d3.event.altKey) {
                var linkData = window.d3.select(this).datum();
                var childIndex = linkData.source.specialChildren.indexOf(linkData.target);
                linkData.source.specialChildren.splice(childIndex, 1);
                window.d3.select("#node" + linkData.source.id).datum(linkData.source);
                window.d3.select(this).remove();
            }
        });
    } catch (ex) {
        me.writeError("updateLink", ex);
    }
};
vcTopologyBuild.prototype.addSignals = function (me) {
    ///<summary>
    ///shows the dialog for adding new nodes to the tree
    ///</summary>
    try {
        me.dialog.html(me.settings.addList);

        me.dialog.dialog("option",
            {
                resizable:false,
                "title": me.settings.resources.topoAddSignals,
                height: parseInt(window._iBrowserHeight * 0.7, 10) ,
               width: 480,
                    appendTo: me.visual,
                buttons: {
                    cancelAdd: {
                        text: me.settings.resources.cancel,
                        click: function() {
                            $(this).dialog().html("");
                            $(this).dialog("close");
                        }
                    },
                    addSignals: {
                        text: me.settings.resources.topoAddSignals,
                        click: function() {
                            me.addToTree(me);
                        }
                    }
                },
                open: function() {
                    $(".tree-add-signal").off("click").on("click", function () {
                        if ($(this).hasClass("selected")) {
                              $(this).find(".fa").removeClass("fa-check-square").addClass("fa-square");
                            $(this).removeClass("selected");
                        } else {
                               $(this).find(".fa").removeClass("fa-square").addClass("fa-check-square");
                            $(this).addClass("selected");
                           
                        }});
                    $('.chkAll').on('change',
                        function() {
                            if ($(this).prop('checked')) {
                                $("#signal-add-list .tree-add-signal.found").find('.fa').removeClass("fa-square").addClass("fa-check-square");
                                $("#signal-add-list .tree-add-signal.found").addClass("selected");
                            } else {
                                    $("#signal-add-list .tree-add-signal.found").find('.fa').removeClass("fa-check-square").addClass("fa-square");
                                                                $("#signal-add-list .tree-add-signal.found").removeClass("selected");

                            }
                            //.prop('checked', );
                        });
                    me.addListFilter();
                }
            }).dialog("open");

    } catch (ex) {
        me.writeError("addSignals", ex);

    }
};
vcTopologyBuild.prototype.addToTree = function (me) {
    ///<summary>
    /// This function adds the in the List Selected Signals  <br/>
    /// to the Currently selected Signal in the tree
    ///</summary>
    try {
        var tempTopo = [];
        var nodeData = window.d3.select(".nA").datum();

        $(".tree-add-signal.selected").each(
            function (index, element) {
                me.visual.find("#divUnass .vc-list-item#bsaid" + $(element).attr("data-bsaid") ).remove();
                var mcount = Math.floor((Math.random() * (Math.pow(10, 6) - 0)) + 0);
                if (nodeData.signalid === "-1" || nodeData.measureunit === $(element).attr('data-measureunit')) {
                           
                    tempTopo.push({
                        signalid: $(element).attr('data-bsaid'),
                        name: $(element).attr('data-name'),
                        count: mcount,
                        id: "" + $(element).attr('data-bsaid') + '_' + mcount,
                        sortid: $(element).attr('data-sortid'),
                        bsagid: $(element).attr('data-bsagid'),
                        isGenerator: $(element).attr('data-isProducer'),
                        measureunit: $(element).attr('data-measureunit')
                    });
                }
            });
        if (!nodeData.children) nodeData.children = [];
        nodeData.children = nodeData.children.concat(tempTopo);
        window.d3.select('#node' + nodeData.id).datum(nodeData);
        $(".tree-add-signal").removeClass("selected");
        $(".tree-add-signal .fa").removeClass("fa-square-checked").addClass("fa-square");
        me.updateTree(me.root, false);                                                 
    } catch (ex) {
        me.writeError('saveSelection', ex);
    }
};

vcTopologyBuild.prototype.onDrag = function (object, d) {
   object.panListener(object, d);
};
vcTopologyBuild.prototype.panListener = function (object, d) {
    var me = object;
    try {
        // get coords of mouseEvent relative to svg container to allow for panning
        me.relCoords = window.d3.mouse($('svg').get(0));
        if (me.relCoords[0] < me.panBoundary) {
            me.panTimer = true;
            me.pan(me, d, 'left');
        } else if (me.relCoords[0] > $('svg').width() - me.panBoundary) {

            me.panTimer = true;
            me.pan(me, d, 'right');
        } else if (me.relCoords[1] < me.panBoundary) {
            me.panTimer = true;
            me.pan(me, d, 'up');
        } else if (me.relCoords[1] > $('svg').height() - me.panBoundary) {

            me.panTimer = true;
            me.pan(me, d, 'down');
        } else {
            try {
                clearTimeout(me.panTimer);
            } catch (e) { me.writeError("panListener", e); }
        }
    } catch (ex) {
        me.writeError("panListener", ex);
    }
};

vcTopologyBuild.prototype.pan = function (object, domNode, direction) {
    /// <summary>does the panning (moving) of the tree</summary>
    /// <returns type="boolean">true if the preparation is ok, false otherwise</returns>
    var me = object;
    try {
        var speed = me.panSpeed;
        var scale;
        if (me.panTimer) {
            clearTimeout(me.panTimer);
            var translateCoords = window.d3.transform(me.svgGroup.attr("transform"));
            var translateX = 0,
            translateY = 0;
            if (direction === 'left' || direction === 'right') {
                translateX = direction === 'left' ? translateCoords.translate[0] + speed : translateCoords.translate[0] - speed;
                translateY = translateCoords.translate[1];
            } else if (direction === 'up' || direction === 'down') {
                translateX = translateCoords.translate[0];
                translateY = direction === 'up' ? translateCoords.translate[1] + speed : translateCoords.translate[1] - speed;
            }
            scale = me.zoomListener.scale();
            me.svgGroup.transition().attr("transform", "translate(" + translateX + "," + translateY + ")scale(" + scale + ")");
            window.d3.select(domNode).select('g.node').attr("transform", "translate(" + translateX + "," + translateY + ")");
            me.zoomListener.scale(me.zoomListener.scale());
            me.zoomListener.translate([translateX, translateY]);
            me.panTimer = setTimeout(function () {
                    me.pan(me, domNode, speed, direction);
                }, 50);
        }
        return true;
    } catch (ex) {
        me.writeError('pan', ex);
        return false;
    }
};